import React, { createContext, createRef, useContext, useMemo } from 'react';
import { useAsyncDisposable } from '../../hooks/useAsyncDisposable';
import { Basic3dLayoutParams, Bootstrapper } from '../domain/Bootstrapper';

type ContextValue = {
  bootstrapper: Bootstrapper;
  canvasRef: React.RefObject<HTMLCanvasElement>;
};

const BootstrapperContext = createContext<ContextValue>({
  bootstrapper: null as any,
  canvasRef: null!,
});

type Props = {
  children: React.ReactNode;
} & Basic3dLayoutParams;

export const BootstrapperProvider = ({ children, ...rest }: Props) => {
  const canvasRef = createRef<HTMLCanvasElement>();
  const bootstrapper = useAsyncDisposable(async () => {
    const bootstrapper = new Bootstrapper(canvasRef.current!, rest);
    await bootstrapper.init();
    return bootstrapper;
  });

  const value = useMemo(() => {
    return {
      bootstrapper,
      canvasRef,
    };
  }, [bootstrapper, canvasRef]);

  return <BootstrapperContext.Provider value={value}>{children}</BootstrapperContext.Provider>;
};

export const useBootstrapper = () => {
  return useContext(BootstrapperContext);
};
